import { useState, useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../../../../../shared/context/auth-context";
import toast from "react-hot-toast";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import ListTratamentoIsolados from "../Lists/ListTratamentoIsolados/ListTratamentoIsolados";
import ModalVerEditarTratamentoIsolado from "./components/ModalEditarTratamentoIsolado/ModalVerEditarTratamentoIsolado";
import ModalCriarTratamentoIsoladoDatasIndividuais from "./components/ModalEditarTratamentoIsolado/ModalCriarTratamentoIsolado/ModalCriarTratamentoIsoladoDatasIndividuais";
import ModalImportarHistorico from "./components/ModalEditarTratamentoIsolado/ModalCriarTratamentoIsolado/ModalImportarHistorico";
import { formatarParaLista } from "./formatoDataDaLista";


function TratamentoIsoladosComponent({
  clienteId,
  sendRequest,
  modalTratamentoIsoladoOpen,
  handleCloseModalTratamentoIsolado,
  modalImportarHistoricoOpen,
  handleCloseModalImportarHistorico,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [tratamentoIsolados, setTratamentoIsolados] = useState([]);

  const handleModalTratamentoIsoladoSubmitSuccess = (novosTratamentos) => {
    const tratamentosFormatados = novosTratamentos.map((tratamento) => ({
      ...tratamento,
      data_inicio_execucao: formatarParaLista(tratamento.data_inicio_execucao),
      data_fim_execucao: formatarParaLista(tratamento.data_fim_execucao),
    }));

    setTratamentoIsolados((current) => [...current, ...tratamentosFormatados]);
    handleCloseModalTratamentoIsolado();
  };

  const auth = useContext(AuthContext);
  //Modal Code
  const [modalData, setModalData] = useState();

  const handleCloseModal = () => {
    setModalData();
  };

  const updateTratamentoIsolados = (tratamentoIsoladoModificada) => {
    setTratamentoIsolados((current) =>
      current.map((c) =>
        c._id === tratamentoIsoladoModificada._id
          ? tratamentoIsoladoModificada
          : c,
      ),
    );
  };
  ///////////////////////////////////////
  useEffect(() => {
    const fetchTratamentoIsoladosByCliente = async () => {
      startLoading();
      try {
        let responseData;
        try {
          responseData = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoisolados/cliente/${clienteId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
        } catch (err) {
          console.error("err", err);
        }

        const temp = responseData.tratamentoIsolados.sort((a, b) => {
          return (
            new Date(b.data_inicio_execucao) - new Date(a.data_inicio_execucao)
          );
        });

        temp.forEach((tratamentoIsolado) => {
          tratamentoIsolado.data_inicio_execucao = formatarParaLista(
            tratamentoIsolado.data_inicio_execucao,
          );
          tratamentoIsolado.data_fim_execucao = formatarParaLista(
            tratamentoIsolado.data_fim_execucao,
          );
        });

        //Filtrando por medico conforme o usuario
        //DEPOIS VERIFICAR OUTROS USUARIOS
        let tempTratamentoIsolados = [];

        if (auth.role === "Secretária(o)" || auth.role === "Assistente") {
          temp.forEach((trIsol) => {
            auth.usuariosAssociados.forEach((medico) => {
              if (medico.id === trIsol.medico._id)
                tempTratamentoIsolados.push(trIsol);
            });
          });
        } else {
          tempTratamentoIsolados = [...temp];
        }

        setTratamentoIsolados(tempTratamentoIsolados);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchTratamentoIsoladosByCliente();
  }, [sendRequest, clienteId, auth]);

  const handleEliminar = async (id) => {
    startLoading();
    try {
      //Encontrar a contaCorrente associada ao orcamento que gerou esse plano
      const tratamentoIsoladoFiltrada = tratamentoIsolados.find(
        (tratamentoIsolado) => tratamentoIsolado._id === id,
      );

      if (!tratamentoIsoladoFiltrada) {
        toast.error("Dados do tratamento não encontrados!");
        return;
      }

      if (
        tratamentoIsoladoFiltrada.entrada &&
        tratamentoIsoladoFiltrada.entrada?.entradaRecebida
      ) {
        toast.error(
          "O tratamento não pode ser eliminado pois já foi recebido!",
        );
        return;
      }

      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      try {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/eliminar/${id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setTratamentoIsolados((current) => current.filter((c) => c._id !== id));
        toast.success(
          `Eliminação do tratamento ${
            tratamentoIsoladoFiltrada.entrada
              ? "e da entrada efetuados"
              : "efetuado"
          } com sucesso!`,
        );
      } catch (err) {
        console.error("err", err);
      }
    } catch (err) {
    } finally {
      stopLoading();
    }
  };

  const handleCancelarExecucao = async (id) => {
    startLoading();
    try {
      //Encontrar a contaCorrente associada ao orcamento que gerou esse plano
      const tratamentoIsoladoFiltrada = tratamentoIsolados.find(
        (tratamentoIsolado) => tratamentoIsolado._id === id,
      );

      if (!tratamentoIsoladoFiltrada) {
        toast.error("Dados do tratamento não encontrados!");
        return;
      }

      if (
        tratamentoIsoladoFiltrada.entrada &&
        tratamentoIsoladoFiltrada.entrada?.entradaRecebida
      ) {
        toast.error(
          "A execução do tratamento não pode ser cancelada porque o tratamento já foi recebido. Cancele o recebimento antes de prosseguir!",
        );
        return;
      }

      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      try {
        const retorno = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/cancelarExecucao/${id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setTratamentoIsolados((current) =>
          current.map((c) =>
            c._id !== id
              ? c
              : {
                  ...retorno.tratamentoIsolado,
                  /* Com o formato da lista, e não `DD/MM/YYYY`.
                   *
                   * Sem as horas, o modal de execução relia a data como
                   * meia-noite e a execução seguinte movia a marcação para lá —
                   * e a agenda, cuja grelha começa às 8h, deixava de a
                   * mostrar. */
                  data_inicio_execucao: formatarParaLista(
                    retorno.tratamentoIsolado.data_inicio_execucao,
                  ),
                  data_fim_execucao: formatarParaLista(
                    retorno.tratamentoIsolado.data_fim_execucao,
                  ),
                },
          ),
        );

        toast.success(
          "Cancelamento de execução do tratamento efetuado com sucesso!",
        );
      } catch (err) {
        console.error("err", err);
      }
    } catch (err) {
    } finally {
      stopLoading();
    }
  };

  const handleOpenModal = (tipo, id) => {
    const tratamentoIsoladoFiltrada = tratamentoIsolados.find(
      (tratamentoIsolado) => tratamentoIsolado._id === id,
    );
    if (!tratamentoIsoladoFiltrada) {
      toast.error("Dados do tratamento Isolado não encontrados!");
      return;
    }

    setModalData({ open: true, data: tratamentoIsoladoFiltrada, tipo: tipo });
  };

  const handleLancarDebito = async (id) => {
    const tratamentoIsoladoFiltrada = tratamentoIsolados.find(
      (tratamentoIsolado) => tratamentoIsolado._id === id,
    );

    startLoading();
    try {
      const formData = new FormData();
      formData.append("tratamentoIsolado", tratamentoIsoladoFiltrada._id);
      formData.append("utilizador", auth.userId);

      const entradaRetornada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoisolados/lancarDebitoTratamentoIsolado/${clienteId}`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      setTratamentoIsolados((current) =>
        current.map((c) =>
          c._id !== id
            ? c
            : {
                ...tratamentoIsoladoFiltrada,
                entrada: entradaRetornada.entrada,
              },
        ),
      );
      toast.success("Valor do tratamento lançado em débito com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  return (
    <>
      {tratamentoIsolados.length !== 0 && (
        <ListTratamentoIsolados
          data={tratamentoIsolados}
          handleOpenModal={handleOpenModal}
          handleEliminar={handleEliminar}
          handleCancelarExecucao={handleCancelarExecucao}
          auth={auth}
          handleLancarDebito={handleLancarDebito}
        />
      )}
      {modalData?.open && (
        <ModalVerEditarTratamentoIsolado
          sendRequest={sendRequest}
          auth={auth}
          dados={modalData.data}
          open={modalData.open}
          tipoModal={modalData.tipo}
          handleCloseModal={handleCloseModal}
          handleModalSubmitSuccess={updateTratamentoIsolados}
        />
      )}
      {/* Data e observação POR tratamento, para todas as clínicas.
          Era uma variante ligada a uma clínica por `if`, com o modal antigo —
          data e observação comuns ao lote inteiro — para as restantes. Passou a
          ser a única: cada procedimento é um acontecimento com a sua data e a
          sua nota, e lançar quatro do mesmo dia continua a dar o mesmo trabalho,
          porque a data do tratamento novo vem já igual à do anterior. */}
      {modalTratamentoIsoladoOpen && (
        <ModalCriarTratamentoIsoladoDatasIndividuais
          sendRequest={sendRequest}
          auth={auth}
          clienteId={clienteId}
          open={modalTratamentoIsoladoOpen}
          handleCloseModal={handleCloseModalTratamentoIsolado}
          handleModalSubmitSuccess={handleModalTratamentoIsoladoSubmitSuccess}
        />
      )}

      {/* Importação de histórico em papel. Modal à parte, e não um modo do de
          cima: escreve por outra rota, marca os registos de outra maneira e
          pede um campo que a criação normal não deve pedir. */}
      {modalImportarHistoricoOpen && (
        <ModalImportarHistorico
          sendRequest={sendRequest}
          auth={auth}
          clienteId={clienteId}
          open={modalImportarHistoricoOpen}
          handleCloseModal={handleCloseModalImportarHistorico}
          handleModalSubmitSuccess={handleModalTratamentoIsoladoSubmitSuccess}
        />
      )}
      {tratamentoIsolados.length === 0 && (
        <div className="no_data_div">Nenhum tratamento Isolado encontrado.</div>
      )}
    </>
  );
}

export default TratamentoIsoladosComponent;
